import { AsYouType } from 'libphonenumber-js';
import { type HTMLInputTypeAttribute } from 'react';

import { isolateNumbers } from 'widget/actions';

const formatValue = (value: string, type: HTMLInputTypeAttribute): string => {
  if (type != 'tel') return value;

  const numbers = isolateNumbers(value);
  const normalized = numbers ? `+${numbers}` : numbers;
  const text = new AsYouType().input(normalized);

  return text;
};

export { formatValue };
